import { z } from 'zod'

export const GetLoadTagTypeSchema = z.object({
  auto_taggable: z.boolean(),
  description: z.string().nullish(),
  id: z.number(),
  is_active: z.boolean(),
  is_system: z.boolean(),
  name: z.string(),
  order: z.number(),
  slug: z.string(),
})

export const GetLoadTagSchema = z.object({
  auto_tagged: z.boolean(),
  created_at: z.coerce.date(),
  id: z.number(),
  tag_type: GetLoadTagTypeSchema.optional(),
})
